module.exports = __webpack_public_path__ + "img/im_scrollfeature_07.8c40a009.jpg";